<!--
 * @Author: your name
 * @Date: 2020-12-10 21:41:22
 * @LastEditTime: 2021-07-12 21:16:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/pc/index.vue
-->
<style scoped lang="sass">
.app_container
  width: 100vw
  height: 100vh
  display: flex
  align-items: center
  justify-content: center
  background: #ececec

  .iframe
    height: 100%
    width: 500PX
    margin: auto
    background: #fff
</style>

<template lang="pug">
.app_container
  iframe.iframe(
    :src="iframeUrl"
    frameborder="0"
  )
</template>

<script>
import resizeHandler from 'utils/resizeHandler'

export default {
  mixins: [resizeHandler],

  watch: {
    isMobile: {
      immediate: true,
      handler(val) {
        if (val && this.iframeUrl) {
          location.href = this.iframeUrl
        }
      }
    },
  },

  mounted() {
    this._goToSite()
  },

  computed: {
    iframeUrl() {
      return this.$route.query.iframeUrl
    }
  },

  methods: {
    _goToSite() {
      const self = this
      window.addEventListener('message', function(e) {
        if (e.data.name === 'goToSite') {
          window.location.href = `${window.location.origin}/site`
        }
      })
    }
  }
}
</script>
